"use client";

/**
 * OwnerBadge
 *
 * Marks a strategy as offered by a 3rd-party (vs. Sovrun-native).
 * Callers gate visibility with `strategy.ownerType === "third_party"` —
 * this component always renders its label when mounted.
 */
export const OwnerBadge = () => {
  return (
    <span className="rounded-full bg-violet-500/20 px-2 py-0.5 text-xs font-semibold text-violet-400">
      3rd-Party
    </span>
  );
};
